import { LokaliseKey, SupportedISOCode, SupportedISOCodes } from '../types/i18n';

export const FALLBACK_LANGUAGE: SupportedISOCode = 'en';
export const LEGACY_LOCALE_FALLBACK: SupportedISOCode = 'es';
export const FALLBACK_LANGUAGE_MOCK: SupportedISOCode = 'en';
export const DEFAULT_LANGUAGE_MOCK: SupportedISOCode = 'en';

export const LOKALISE_KEYS: LokaliseKey[] = [
  {
    isoCode: 'es',
    lokaliseKey: 'language.spanish'
  },
  {
    isoCode: 'en',
    lokaliseKey: 'language.english'
  }
];

export const SUPPORTED_ISO_CODES: SupportedISOCode[] = Object.keys(SupportedISOCodes).filter((x) =>
  isNaN(+x)
) as SupportedISOCode[];

export const LANGUAGES_KEYS = {
  es: 'language.spanish',
  en: 'language.english',
  pt: 'language.portuguese'
};
